export default function LightTexture() {
  return (
    <div className="hero-light-texture pointer-events-none opacity-100 absolute inset-0 z-10" />
  );
}
